import { AppColors } from "./AppColors";

export const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };
export const plusBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
export const delBtn = { color: AppColors.red, width: 20, height: 20 };
export const eyeBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
export const w20h20BlueIcon = {
  color: AppColors.appPrimary,
  width: 20,
  height: 20,
};
export const w15h15BlueIcon = {
  width: 15,
  height: 15,
  color: AppColors.appPrimary,
};
export const w25h25BlueIcon = {
  width: 25,
  height: 25,
  color: AppColors.appPrimary,
};
export const w20h20GreenIcon = {
  color: AppColors.green2,
  width: 20,
  height: 20,
};
export const w10h10GrayIcon = { color: AppColors.gray, width: 10, height: 10 };
